import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './languages/en';
import es from './languages/es';
import id from './languages/id';
import ar from './languages/ar';
import hi from './languages/hi';
import ne from './languages/ne';
import mr from './languages/mr';
import pt from './languages/pt';
import fr from './languages/fr';
import bn from './languages/bn';
import am from './languages/am';
import zh from './languages/zh';
import tr from './languages/tr';
import ja from './languages/ja';
import el from './languages/el';
import vi from './languages/vi';

import so from './languages/so';
import om from './languages/om';
import sw from './languages/sw';

Vue.use(VueI18n);

const messages = {
    'en': en,
    'es': es,
    'id': id,
    'ar': ar,
    'hi': hi,
    'ne': ne,
    'mr': mr,
    'pt': pt,
    'fr': fr,
    'bn': bn,
    'am': am,
    'zh': zh,
    'tr': tr,
    'ja': ja,
    'el': el,
    'vi': vi,
    'so': so,
    'om': om,
    'sw': sw
};

var language = localStorage.getItem('LANGUAGE')
if( language == null){
    language = 'en'
}

export default new VueI18n({
    locale: language,
    silentTranslationWarn: true,
    fallbackLocale: 'en',
    messages,
});